import { render, staticRenderFns } from "./BeginnersGuide.vue?vue&type=template&id=7d35e692"
import script from "./BeginnersGuide.vue?vue&type=script&lang=js"
export * from "./BeginnersGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports